<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('AllWarehouses')">
            <AllWarehouses></AllWarehouses>
          </vs-tab>
          <vs-tab :label="$t('DividedByWarehouseAndShelve')">
            <DividedByWarehouseAndShelve></DividedByWarehouseAndShelve>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import AllWarehouses from "./AllWarehouses.vue";
import DividedByWarehouseAndShelve from "./DividedByWarehouseAndShelve.vue";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "warehouseManagement_Balance_Index",
  components: {
    AllWarehouses,
    DividedByWarehouseAndShelve
  }
};
</script>
